export default __webpack_public_path__ + "static/media/Planning.c65b7536.jpg";